import React from 'react';
import { FormattedMessage } from 'react-intl';
import { searchConstants } from '../../../../search-utils/searchConstants';
import { doctrineAnalytics } from '../../../../../utils/analyticsUtils';
import { TextButton } from '../../../../../components/button';
import styles from './date_range_selector.module.scss';
import { SearchFiltersRadioContent } from '../../../search-filters-radio/SearchFiltersRadioContent';

type Props = {
  accessPremium: boolean;
  openRestrictedModal: Function;
  onDatesUpdate: Function;
  selectedValue: { from?: string; to?: string };
};

type State = {
  from: string;
  to: string;
};

export class DateRangeSelector extends React.Component<Props, State> {
  constructor(props: Props) {
    super(props);
    this.state = {
      from: props.selectedValue.from ? props.selectedValue.from : '1800',
      to: props.selectedValue.to
        ? props.selectedValue.to
        : String(searchConstants.years.yearNow),
    };
  }

  onRangeChange = (evt: React.ChangeEvent<HTMLInputElement>) => {
    const { name, value } = evt.currentTarget;

    this.setState({
      [name]: value,
    } as Pick<State, keyof State>);
  };

  submitYearRange = (evt: React.FormEvent<HTMLFormElement>) => {
    evt.preventDefault();
    const { accessPremium, openRestrictedModal, onDatesUpdate } = this.props;
    if (!accessPremium) {
      openRestrictedModal('faceted-item');
    } else {
      const { to, from } = this.state;
      const dateRange = { to, from };
      doctrineAnalytics('Search DatePickerDayClicked', {
        ...dateRange,
        search_type: 'decision',
        type: 'year_range',
      });
      onDatesUpdate(dateRange);
    }
  };

  render() {
    const { from, to } = this.state;

    return (
      <SearchFiltersRadioContent>
        <div className={styles.container}>
          <form className={styles.form} onSubmit={this.submitYearRange}>
            <input
              className={styles.input}
              name="from"
              minLength={4}
              maxLength={4}
              value={from}
              onChange={this.onRangeChange}
              required
            />
            <input
              className={styles.input}
              minLength={4}
              maxLength={4}
              name="to"
              value={to}
              onChange={this.onRangeChange}
              required
            />
            <TextButton type="submit">
              <FormattedMessage id="search/components/aside-filters/dates/range-selection/DateRangeSelector.tsx/1" />
            </TextButton>
          </form>
        </div>
      </SearchFiltersRadioContent>
    );
  }
}
